import {
	Component,
	Input,
	OnInit
}                         from '@angular/core';
import { FormGroup }      from '@angular/forms';
import { BaseComponent }  from '@core/bases/base-component/base.component';
import {
	IFormBaseData,
	IFormGenericSelectItem
}                         from '@core/interfaces/form.interface';
import { SalutationEnum } from '@models/common.model';
import { FormUtils }      from '@shared/forms/helpers';
import {
	INaturalPersonForm,
	NaturalPersonFormProp
}                         from '@shared/forms/natural-person-form/natural-person-form.model';
import { DateUtils }      from '@utils/helpers';
import { takeUntil }      from 'rxjs/operators';

@Component( {
	selector: 'app-natural-person-form[naturalPersonForm][formConfigData]',
	templateUrl: './natural-person-form.component.html',
	styleUrls: [ './natural-person-form.component.scss' ]
	// intentionally no providers here - it's used as subform, don't use as standalone
} )
export class NaturalPersonFormComponent extends BaseComponent implements OnInit {

	public salutationList: IFormGenericSelectItem<SalutationEnum>[];
	public birthdayMaxDate: Date;
	public birthdayMinDate: Date;

	@Input() disableControls: boolean;
	@Input() hideErrors: boolean;
	@Input() formConfigData: IFormBaseData;
	@Input() naturalPersonForm: FormGroup<INaturalPersonForm>;
	@Input() showForm = false;

	constructor() {
		super();
	}

	private setSalutationList(): void {
		const salutationList: IFormGenericSelectItem<SalutationEnum>[] = [];

		const salutationOrderedList: SalutationEnum[] = [
			SalutationEnum.MR,
			SalutationEnum.MRS,
			SalutationEnum.OTHER
		];

		salutationOrderedList.forEach( ( salutation: SalutationEnum ) => {
			const formSelectItem: IFormGenericSelectItem<SalutationEnum> = {
				label: this.getI18nString( false, `shared.salutation.${ salutation }` ),
				value: salutation
			};

			salutationList.push( formSelectItem );
		} );

		this.salutationList = salutationList;
	}

	private setBirthdateRanges(): void {
		const today: Date = new Date();
		this.birthdayMaxDate = today;
		this.birthdayMinDate = DateUtils.shiftDate( today, { years: -120 } );
	}

	ngOnInit(): void {
		this.setBirthdateRanges();

		// updates salutationList on language change
		this.uiService.languageHasChanged$
		.pipe( takeUntil( this.ngUnsubscribe ) )
		.subscribe( () => {
			this.setSalutationList();
		} );
	}

	hasRequiredValidator( formProp: NaturalPersonFormProp ): boolean {
		return FormUtils.hasRequiredValidator( this.naturalPersonForm, formProp );
	}
}
